import {cloneDeep} from 'lodash';
import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import Utility from '../../util/utilityfunctions';
import {currentResource} from '../../util/utils';
import {QuickFilterTypes} from '../../util/uiconstants';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      storeIgua.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function getPICEQRReviewNotesFilters(state = initialState.piceqrrnhFilters, action) {
	switch (action.type) {
		case types.PIC_EQR_SET_RNH_FILTERS: {
			let piceqrrnhFilters = {...action.filters};
			piceqrrnhFilters.isLoaded = true;
			return piceqrrnhFilters;
		}
		case types.PIC_EQR_SET_RNH_FILTER: {
			let value = action.value;
			if (!Utility.hasValue(value)) {
				// If filter is being disabled, set to empty array so it's removed from the URL.
				value = [];
			}

			let filters;
			filters = {...state};
			if (action.filterItemName) {
				filters[action.filterItemName] = value;
			}

			// Page number must be reset to 1.
			filters.isLoaded = true;

			return {
				...state,
				...filters
			};
		}
		case types.PIC_EQR_CLEAR_RNH_FILTERS: {
			let piceqrrnhFilters = cloneDeep(state);

			Object.keys(piceqrrnhFilters).forEach((key) => {
				if (currentResource.rnhFilterType.find((x) => x.inDropDown && x.filterType === key) || key == QuickFilterTypes.annotationstatusids) {
					piceqrrnhFilters[key] = [];
				}
			});

			return piceqrrnhFilters;
		}
		default:
			return state;
	}
}
